export default __webpack_public_path__ + "static/media/group-checkbox.a801307b.svg";